// @flow

import { applyMiddleware, combineReducers, createStore, compose } from "redux"; 
import thunk from "redux-thunk";
import V3AccountReducers from "./v3/account/reducers/index";
import V3AdminReducers from "./v3/admin/reducers/index";

const reducers = combineReducers({
  v3account: V3AccountReducers,
  v3admin: V3AdminReducers
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = [ thunk ];

const Store = createStore(
  reducers,
  composeEnhancers( applyMiddleware(...middleware) )
);


export default Store;